









































import Draggable from 'vuedraggable';

export default {
  props: {
    canReorder: Boolean,
    selectedIndex: Number,
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    panelIndex: null,
  }),
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      },
    },
    realIndex() {
      return this.selectedIndex === undefined
        ? this.panelIndex
        : this.selectedIndex;
    },
  },
  methods: {
    toggle(index: number) {
      // If selectedIndex prop provided we're assuming the
      // accordion can be controlled externally so default to that.
      // If not, then use internal counter
      this.panelIndex = this.selectedIndex === undefined
        ? (this.panelIndex === index ? null : index)
        : (this.selectedIndex === index ? null : index);

      // emit
      this.$emit('open', this.panelIndex);
    },
  },
  components: {
    Draggable,
  },
} as IView;
